export const isEmbedSmartLinkView = () =>
	window &&
	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	window?.location.pathname.includes('plans') &&
	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	window?.location.pathname.includes('scenarios') &&
	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	window?.location.pathname.includes('/embed');
